<form [formGroup]="form"
      (ngSubmit)="submit($event)">
  <mat-form-field subscriptSizing="dynamic">
    <textarea cdkTextareaAutosize
              matInput
              [placeholder]="placeholderText()"
              formControlName="evaPrompt"
              cdkAutosizeMinRows="4"
              cdkAutosizeMaxRows="6"
              [matAutocomplete]="suggested.panel()"
              (keydown.enter)="submit($event)">
	</textarea>

    <div class="chat-actions">
      <button mat-flat-button
              icon-only
              type="button"
              [attr.aria-label]="isCallingApi() ? 'Stop' : 'Send'"
              color="accent"
              [disabled]="sendDisabled()"
              (click)="handlePromptAction()">
        <mat-icon>
          {{ isCallingApi() ? 'stop' : 'arrow_shape_up' }}
        </mat-icon>
      </button>

    </div>
  </mat-form-field>

  <ez-eva-suggested-prompts #suggested
                            [prompts]="suggestedPrompts()"
                            [showStaticPrompts]="showStaticPrompts()"
                            [excludedStaticPrompts]="excludedStaticPrompts()"
                            [query]="typedQuery()"
                            (promptSelected)="onSuggestedPromptSelected($event)" />

  <span class="eva-warn-message">
    EVA can make mistakes. Check important info.
  </span>
</form>